import { render, staticRenderFns } from "./BuildInputDrawer.vue?vue&type=template&id=4603a268"
import script from "./BuildInputDrawer.vue?vue&type=script&lang=js"
export * from "./BuildInputDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports